import { Component, Inject, Injector, ViewEncapsulation, Optional, Input, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: "ds-modal",
  templateUrl: "./ds-modal.component.html",
  styleUrls: ["./ds-modal.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class DsModalComponent implements OnInit {
  childInjector!: Injector;
  modalData: any = {};

  @Input() title?: string;
  @Input() description?: string;
  /** When true, the description is rendered as HTML (innerHTML) instead of plain text. */
  @Input() descriptionHtml = false;
  @Input() submitLabel?: string;
  @Input() cancelLabel?: string;
  @Input() component?: any;
  @Input() data?: any;
  /** When true, content uses bottom-sheet layout (used in component mode; dialog mode reads from MAT_DIALOG_DATA). */
  @Input() fixedBottom = false;
  /** Optional ds-icon shown next to the title (as a 32px circular badge). */
  @Input() titleDsIcon?: string;

  get isDialogMode(): boolean {
    return !!this.dialogRef;
  }

  constructor(
    @Optional() @Inject(MAT_DIALOG_DATA) private dialogData: any,
    @Optional() private dialogRef: MatDialogRef<DsModalComponent>,
    private injector: Injector
  ) {}

  ngOnInit(): void {
    if (this.isDialogMode) {
      this.modalData = {
        title: this.dialogData?.title,
        description: this.dialogData?.description,
        descriptionHtml: this.dialogData?.descriptionHtml ?? false,
        submitLabel: this.dialogData?.submitLabel,
        cancelLabel: this.dialogData?.cancelLabel,
        stateSubmit: this.dialogData?.stateSubmit,
        stateCancel: this.dialogData?.stateCancel,
        disabledSubmit: this.dialogData?.disabledSubmit ?? false,
        disabledCancel: this.dialogData?.disabledCancel ?? false,
        loadingSubmit: this.dialogData?.loadingSubmit ?? false,
        loadingCancel: this.dialogData?.loadingCancel ?? false,
        loadingTextSubmit: this.dialogData?.loadingTextSubmit ?? "Cargando",
        loadingTextCancel: this.dialogData?.loadingTextCancel ?? "Cargando",
        innerComponent: this.dialogData?.innerComponent || null,
        innerComponentData: this.dialogData?.innerComponentData,
        onSubmit: this.dialogData?.onSubmit,
        onCancel: this.dialogData?.onCancel,
        cancelDsIcon: this.dialogData?.cancelDsIcon,
        submitDsIcon: this.dialogData?.submitDsIcon,
        titleDsIcon: this.dialogData?.titleDsIcon,
        fixedBottom: this.dialogData?.fixedBottom ?? false,
      };
    } else {
      this.modalData = {
        title: this.title,
        description: this.description,
        descriptionHtml: this.descriptionHtml,
        submitLabel: this.submitLabel,
        cancelLabel: this.cancelLabel,
        innerComponent: this.component || null,
        innerComponentData: this.data,
        fixedBottom: this.fixedBottom,
        titleDsIcon: this.titleDsIcon,
      };
    }

    this.childInjector = Injector.create({
      providers: [
        { provide: "dsModalData", useValue: this.modalData.innerComponentData },
        { provide: "dsModalConfig", useValue: this.modalData },
        ...(this.dialogRef ? [{ provide: MatDialogRef, useValue: this.dialogRef }] : []),
      ],
      parent: this.injector,
    });
  }

  close() {
    if (this.isDialogMode) {
      this.dialogRef?.close();
    }
  }

  submit() {
    if (this.modalData.disabledSubmit || this.modalData.loadingSubmit) {
      return;
    }

    if (this.modalData.onSubmit) {
      const result = this.modalData.onSubmit();
      if (result !== false) {
        if (this.isDialogMode) {
          this.dialogRef?.close(result || true);
        }
      }
    } else {
      if (this.isDialogMode) {
        this.dialogRef?.close(true);
      }
    }
  }

  onClose() {
    if (this.modalData.disabledCancel || this.modalData.loadingCancel) {
      return;
    }

    if (this.modalData.onCancel) {
      const result = this.modalData.onCancel();
      if (result !== false) {
        if (this.isDialogMode) {
          this.dialogRef?.close(result || false);
        }
      }
    } else {
      if (this.isDialogMode) {
        this.dialogRef?.close(false);
      }
    }
  }
}
